import { SelectableChip } from './SelectableChip';

type SelectableChipGroupProps = {
  readonly options: {
    readonly label: string;
    readonly value: string;
  }[];
  readonly selectedOptions: string[];
  readonly onSelectionChange: (selectedOption: string) => void;
};

export const SelectableChipGroup: React.FC<SelectableChipGroupProps> = ({
  options,
  selectedOptions,
  onSelectionChange,
}: SelectableChipGroupProps) => (
  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
    {options.map((option) => (
      <SelectableChip
        key={option.value}
        label={option.label}
        isSelected={selectedOptions.includes(option.value)}
        onSelectChange={() => onSelectionChange(option.value)}
      />
    ))}
  </div>
);
